import { useState } from 'react';

const useShowModal = (removeDataOnClose = true) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  const handleOpenModal = data => {
    setIsOpen(true);
    setModalData(data);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
    if (removeDataOnClose) {
      setModalData(null);
    }
  };

  return {
    isOpen,
    modalData,
    handleOpenModal,
    handleCloseModal
  };
};

export default useShowModal;
